import { FC } from 'react'
import editImage from '../assets/edit.svg'
import deleteImage from '../assets/delete.svg'
import ActionButton, { ActionButtonProps } from './ActionButton'

type GroupItemProps = {
  groupName: string
  onEdit: () => void
  onDelete: () => void
}

const GroupItem: FC<GroupItemProps> = ({ groupName, onEdit, onDelete }) => {
  const iconButtonStyles: Pick<
    ActionButtonProps,
    'type' | 'padding' | 'styles'
  > = {
    type: 'secondary',
    padding: 'sqsm',
    styles: 'ml-2 h-6 w-6 rounded-md',
  }

  return (
    <div className="flex justify-between items-center border-b border-iconGreySecondary py-[6.5px]">
      <p className="text-sm">{groupName}</p>
      <div className="flex">
        <ActionButton ariaLabel="edit" onClick={onEdit} {...iconButtonStyles}>
          <img src={editImage} alt="edit" />
        </ActionButton>

        <ActionButton
          ariaLabel="delete"
          onClick={onDelete}
          {...iconButtonStyles}
        >
          <img src={deleteImage} alt="delete" />
        </ActionButton>
      </div>
    </div>
  )
}

export default GroupItem
